import { createAsyncThunk } from '@reduxjs/toolkit';
import jwt_decode from 'jwt-decode';

import { ApiCacheTagsArray, baseApiService } from '../../core';
import { clearCredentials, setCredentials, setToken } from '../store';
import { TUserAuthTokenPayload } from '../types';

export const loginThunk = createAsyncThunk<void, string>('auth/login', async (accessToken, { dispatch }) => {
    const decoded: TUserAuthTokenPayload = jwt_decode(accessToken);

    dispatch(setCredentials({ accessToken, user: decoded }));
    localStorage.setItem('accessToken', accessToken);
});

export const tokenThunk = createAsyncThunk<void, string>('auth/token', async (accessToken, { dispatch }) => {
    dispatch(setToken(accessToken));
});

export const logoutThunk = createAsyncThunk<void>('auth/logout', async (_, { dispatch }) => {
    dispatch(clearCredentials());
    localStorage.removeItem('accessToken');
    dispatch(baseApiService.util.invalidateTags(ApiCacheTagsArray));
});
